import { Modal, Radio } from 'antd';
import { Dispatch, SetStateAction, useState } from 'react';
import close from '../../../assets/RoundedClose.svg';
import i from '../../../assets/i.svg';
import { tenderDataProps } from '../../../pages/TenderViewPage/types';

interface PropsI {
    openModal: boolean;
    setOpenModal: Dispatch<SetStateAction<boolean>>;
    data: tenderDataProps;
}

export const capitalize = (value?: string) => (value ? value.charAt(0).toUpperCase() + value.slice(1) : '');

export const ViewSupplierListModal = ({ openModal, setOpenModal, data }: PropsI) => {
    const supplierList = data?.invited_suppliers?.items;
    const [type, setType] = useState<string>('all');

    console.log('supplierList', supplierList);

    const filteredSuppliers = supplierList?.filter((elem) => {
        if (type === 'all') {
            return elem;
        }
        if (type === 'registered') {
            return elem.registration_status === 'registered';
        }
    });

    const options = [
        { label: `Matched All (${data?.invited_suppliers?.total_count})`, value: 'all' },
        { label: `Registered (${data?.invited_suppliers?.completed_registration})`, value: 'registered' }
    ];

    return (
        <Modal
            className="modal-supp-list"
            destroyOnClose
            centered
            open={openModal}
            onOk={() => {}}
            onCancel={() => {
                setOpenModal(false);
            }}
            closeIcon={<img src={close} />}
            footer={<></>}
            width={800}
        >
            <div className="modal">
                <div className="modal__header meeting" style={{ height: '88px' }}>
                    <div className="modal__title">Supplier List</div>
                </div>

                <div className="modal__main main" style={{ padding: '24px 56px 43px 56px' }}>
                    <div className="note">
                        <img src={i} />
                        <div>
                            Our supplier onboarding team is actively onboarding suppliers matched to your requirements
                            from our database, as well as any suppliers you may have put forward.
                        </div>
                    </div>
                    <div className="custom-radio-field">
                        <Radio.Group
                            value={type}
                            className={`notif-radio-switcher`}
                            onChange={(e) => setType(e.target.value)}
                        >
                            {options.map((option) => (
                                <Radio.Button key={option.value} value={option.value}>
                                    {option.label}
                                </Radio.Button>
                            ))}
                        </Radio.Group>
                    </div>
                    <div className="modal-supp-list__list">
                        {filteredSuppliers?.map((supp) => {
                            return (
                                <div className="modal-supp-list__supp">
                                    <div className="modal-supp-list__supp-col">
                                        {supp?.company?.is_candidate && (
                                            <div className="modal-supp-list__supp-col-added">Added by buyer</div>
                                        )}
                                        <div className="modal-supp-list__supp-col-title">{supp.company.name}</div>
                                    </div>
                                    <div className={`modal-supp-list__supp-${supp?.registration_status}`}>
                                        {capitalize(supp?.registration_status)}
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>
        </Modal>
    );
};
